import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { isAuthenticated } from '../../../../services/auth';
import { Button, message } from 'antd';
import { Avatar as MUIAvatar } from '@mui/material';
import { UploadOutlined, UserOutlined, ArrowLeftOutlined } from '@ant-design/icons';
import { getUser, editUser } from '../../../../services/user';
import { registerUser } from '../../../../services/admin';
import UnifiedDashboard from '../../../../components/layout/unified-dashboard';

const UpsertProfile = ({ match, hideBackButton = false }) => {
  const history = useHistory();
  const [values, setValues] = useState({
    name: '',
    username: '',
    email: '',
    phone: '',
    photo: null,
    photoUrl: '',
    password: '',
    confirmPassword: '',
  });

  const { name, username, email, phone, photo, photoUrl, password, confirmPassword } = values;
  const { user, token } = isAuthenticated();

  const loadUser = async () => {
    let data = await getUser(match.params.userId);
    setValues(v => ({
      ...v,
      name: data.data.name,
      username: data.data.username,
      email: data.data.email,
      phone: data.data.phone,
      photoUrl: data.data.photo ? `${process.env.REACT_APP_API?.replace(/\/api$/, '') }${data.data.photo.replace(/^[\.\/]playnoimovel\.com\.br\/api/, '')}` : '',
    }));
  };

  useEffect(() => {
    if (match.params.userId !== 'new') {
      loadUser();
    }
    // eslint-disable-next-line
  }, []);

  const handleChange = (name) => (event) => {
    const value = name === 'photo' ? event.target.files[0] : event.target.value;
    setValues({ ...values, [name]: value, ...(name === 'photo' ? { photoUrl: URL.createObjectURL(value) } : {}) });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (match.params.userId === 'new') {
      // Creating new user
      if (password !== confirmPassword) {
        message.error('As senhas não coincidem', 4);
        return;
      }
      let userData = new FormData();
      userData.append('name', name);
      userData.append('username', username);
      userData.append('email', email);
      userData.append('phone', phone);
      userData.append('password', password);
      if (photo) userData.append('photo', photo);
      try {
        await registerUser(userData);
        message.success('Usuário criado com sucesso', 4);
        history.push('/admin/users');
      } catch (err) {
        if (err.response?.status === 400) message.error(err.response.data?.error || err.response.data, 4);
      }
    } else {
      // Updating existing user
      let userData = new FormData();
      userData.append('name', name);
      userData.append('username', username);
      userData.append('email', email);
      userData.append('phone', phone);
      userData.append('adminAuth', user.role);
      if (photo) userData.append('photo', photo);
      try {
        await editUser(match.params.userId, userData, token);
        message.success('Perfil atualizado com sucesso', 4);
        if (user.role !== 'admin') {
          window.location.reload();
        }
      } catch (err) {
        if (err.response?.status === 400) message.error(err.response.data, 4);
      }
    }
  };

  const handlePhotoClick = () => {
    document.getElementById('photo-upload').click();
  };

  const editProfileForm = () => (
    <form onSubmit={handleSubmit} className='edit-profile-form'>
      {/* Avatar Section */}
      <div className='edit-profile-avatar-section'>
        <div className='edit-profile-avatar-container'>
          <MUIAvatar
            src={photoUrl}
            sx={{ width: 100, height: 100, '& img': { objectFit: 'cover' } }}
          >
            <UserOutlined />
          </MUIAvatar>
          <input
            id='photo-upload'
            type='file'
            accept='image/*'
            className='edit-profile-upload-input'
            onChange={handleChange('photo')}
          />
          <Button 
            icon={<UploadOutlined />} 
            type='default'
            size='small' 
            className='edit-profile-upload-btn'
            onClick={handlePhotoClick}
          />
        </div>
      </div>

      {/* Form Fields */}
      <div className='form-group'>
        <label className='form-label edit-profile-label'>Nome</label>
        <input
          type='text'
          className='form-control shadow-none edit-profile-input'
          placeholder='Digite o nome completo'
          value={name}
          onChange={handleChange('name')}
        />
      </div>

      <div className='form-group'>
        <label className='form-label edit-profile-label'>Nome de usuário</label>
        <input
          type='text'
          className='form-control shadow-none edit-profile-input'
          placeholder='Digite o nome de usuário'
          value={username}
          onChange={handleChange('username')}
        />
      </div>

      <div className='form-group'>
        <label className='form-label edit-profile-label'>E-mail</label>
        <input
          type='email'
          className='form-control shadow-none edit-profile-input'
          placeholder='Digite o e-mail'
          value={email}
          onChange={handleChange('email')}
        />
      </div>

      <div className='form-group'>
        <label className='form-label edit-profile-label'>Telefone</label>
        <input
          type='tel'
          className='form-control shadow-none edit-profile-input'
          placeholder='(00) 00000-0000'
          value={phone}
          onChange={handleChange('phone')}
        />
      </div>

      {match.params.userId === 'new' && (
        <>
          <div className='form-group'>
            <label className='form-label edit-profile-label'>Senha</label>
            <input
              type='password'
              className='form-control shadow-none edit-profile-input'
              placeholder='Digite a senha'
              value={password}
              onChange={handleChange('password')}
            />
          </div>

          <div className='form-group'>
            <label className='form-label edit-profile-label'>Confirmar Senha</label>
            <input
              type='password'
              className='form-control shadow-none edit-profile-input'
              placeholder='Confirme a senha'
              value={confirmPassword}
              onChange={handleChange('confirmPassword')}
            />
          </div>
        </>
      )}

      {/* Submit Button */}
      <div className='edit-profile-submit-container'>
        <Button
          type='primary'
          size='large'
          htmlType='submit'
          className='edit-profile-submit-btn'
        >
          {match.params.userId === 'new' ? 'Criar Usuário' : 'Salvar Alterações'}
        </Button>
      </div>
    </form>
  );

  return (
    <UnifiedDashboard>
      <div className='edit-profile-container'>
        <div className='edit-profile-header-section'>
          {!hideBackButton && (
            <button 
              className='edit-profile-back-btn-header'
              onClick={() => history.goBack()}
              title="Voltar"
            >
              <ArrowLeftOutlined />
            </button>
          )}
          <h2 className='edit-profile-title'>
            <i className='fas fa-user-edit'></i>
            {match.params.userId === 'new' ? 'Criar Usuário' : 'Editar Perfil'}
          </h2>
          <p className='edit-profile-subtitle'>
            {match.params.userId === 'new' ? 'Cadastre um novo usuário no sistema' : 'Atualize suas informações pessoais'}
          </p>
        </div>
        <div className='edit-profile-content-wrapper'>
          {editProfileForm()}
        </div>
      </div>
    </UnifiedDashboard>
  );
};

export default UpsertProfile;
